import Grid from '@mui/material/Grid';
import { useEffect } from 'react';

import BaseTopMatter from 'reservations/account/components/BaseTopMatter';
import LocationCard from 'reservations/account/components/LocationCard';
import LocationListTopMatter from 'reservations/account/components/LocationListTopMatter';
import { useAccount } from 'reservations/account/providers/AccountProvider';
import { ConfigProvider } from 'reservations/account/providers/ConfigProvider';
import { LayoutWithGutter } from 'reservations/base/components/LayoutWithGutter';
import PageLoadSpinner from 'reservations/base/components/PageLoadSpinner';
import { getAvailabilitiesUrl } from 'reservations/base/helpers/routes';
import { useCustomRouter } from 'reservations/base/providers/RouterProvider';
import BackgroundOverlayImageWrapper from 'reservations/brand/components/BackgroundOverlayImageWrapper';

function LocationListScreen() {
  const { handleNavigation } = useCustomRouter();
  const {
    connected_location_integrations: connectedLocationIntegrations,
    restaurantName
  } = useAccount();
  const isSingleLocation = connectedLocationIntegrations.length === 1;

  useEffect(() => {
    if (isSingleLocation) {
      const availabilitiesUrl = getAvailabilitiesUrl(
        connectedLocationIntegrations[0].location.slug
      );

      handleNavigation(availabilitiesUrl);
    }
  }, []);

  // Before the useEffect redirects us, we want to make sure
  // that we don't render any of the location cards
  // so we instead render the page load spinner
  if (isSingleLocation) {
    return <PageLoadSpinner />;
  }

  const locationCards = connectedLocationIntegrations.map(
    ({ location }, index) => (
      <Grid
        key={location.id}
        item
        mb={index !== connectedLocationIntegrations.length - 1 ? '20px' : 0}
      >
        <ConfigProvider slug={location.slug}>
          <LocationCard {...location} />
        </ConfigProvider>
      </Grid>
    )
  );

  return (
    <>
      <BaseTopMatter />
      <LayoutWithGutter>
        <BackgroundOverlayImageWrapper>
          <LocationListTopMatter restaurantName={restaurantName} />
        </BackgroundOverlayImageWrapper>
        <Grid container direction="column" alignItems="center">
          <Grid item sx={{ width: '100%', p: '20px' }}>
            {locationCards}
          </Grid>
        </Grid>
      </LayoutWithGutter>
    </>
  );
}

export default LocationListScreen;
